import { render } from "./ProductDetailEdit.vue?vue&type=template&id=b7632368&ts=true"
import script from "./ProductDetailEdit.vue?vue&type=script&lang=ts"
export * from "./ProductDetailEdit.vue?vue&type=script&lang=ts"

import exportComponent from "/root/.jenkins/workspace/test-saas-doctor/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__